import {
    isFunction,
    bridgeCall,
    isAndroid,
    withFusion,
    getWindow
} from '../util';
let theWindow = getWindow();

import {
    CONFIG
} from '../config/config';

import {
    Global
} from './global';

export class FusionClass {
    constructor(version) {
            this.version = version;
            // this.getModuleMethods();
        }
        /**
         * JS 调用 Native
         *
         * @param      {string}  module  模块名
         * @param      {string}  method  方法名
         */
    invokeNative(module, method) {
        return function(...params) {
            let args = [];
            const globalInstance = Global.getInstance();
            let cbName = globalInstance.callbackId.toString();
            for (let i in params) {
                // 防止被不法分子坑，遍历出原型上的东西
                if (params.hasOwnProperty(i)) {
                    if (isFunction(params[i])) {
                        globalInstance.callbacks[cbName] = params[i];
                        args.push(cbName);
                        globalInstance.callbackId++;
                    } else {
                        args.push(params[i]);
                    }
                }
            }
            bridgeCall('invokeNative', module, method, args);
        };
    }

    /**
     * Native 回调 JS
     *
     * @param      {number}  callbackID  回调函数 ID
     * @param      {array}   arg         回调参数
     */
    callbackJS(cbName, args) {
        const globalInstance = Global.getInstance();
        let callback = globalInstance.callbacks[cbName];
        if (callback && isFunction(callback)) {
            callback.apply(null, args);
        }
        globalInstance.callbacks[cbName] = function() {};
    }

    /**
     * Native 调用 JS 函数接口
     *
     * @param      {string}  module     The module
     * @param      {string}  method     The method name
     * @param      {array}   args       The arguments
     */
    invokeJSMethod(module, method, args) {
        let newArgs = [];
        const callbackIdRegExp = /^__\${(\d)+}__$/;
        for (let i in args) {
            if (callbackIdRegExp.exec(args[i])) {
                let callbackId = callbackIdRegExp.exec(args[i])[1];
                let self = this;
                let func = function(...params) {
                    self.callbackNative(callbackId, params);
                };
                newArgs.push(func);
            } else {
                newArgs.push(args[i]);
            }
        }
        if (CONFIG.SYS_MODULE.indexOf(module) !== -1) {
            this[method](...newArgs);
            return;
        }
        let object = this.loadModule(module);
        object[method].apply(null, newArgs);
    }

    /**
     * Native 回调 JS
     *
     * @param      {number}  cbName     回调函数 ID
     * @param      {array}   args       回调参数
     */
    callbackNative(cbName, args) {
        bridgeCall('callbackNative', null, cbName, args);
    }

    /**
     * 注册（多个）模块
     *
     * @param      {array}  modules    模块对象列表
     */
    registerModules(modules) {
        for (let i in modules) {
            if (CONFIG.SYS_MODULE.indexOf(modules[i].module) >= 0) {
                for (let j in modules[i].methods) {
                    if (!this[modules[i].methods[j]]) {
                        this[modules[i].methods[j]] = this.invokeNative(modules[i].module, modules[i].methods[j]);
                    }
                }
            } else {
                this.registerModule(modules[i].module);
                for (let j in modules[i].methods) {
                    let object = this.loadModule(modules[i].module);
                    object.registerFn(modules[i].methods[j]);
                }
            }
        }
    };

    /**
     * 注册单个模块
     *
     * @param      {object}  modules    模块对象
     */
    registerModule(module) {
        const globalInstance = Global.getInstance();
        let object = globalInstance.modules[module];
        if (!object) {
            let self = this;
            globalInstance.modules[module] = Object.create({
                registerFn(method) {
                    this[method] = self.invokeNative(module, method);
                }
            });
        }
    }

    /**
     * 加载模块
     *
     * @param      {string}  module     模块名称
     */
    loadModule(module) {
            const globalInstance = Global.getInstance();
            let object = globalInstance.modules[module];
            if (object) {
                return object;
            }
            this.registerModule(module);

            return globalInstance.modules[module];
        }
        /**
         * 获取客户端内置模块
         *
         */
    fetchJSModules() {
        if (isAndroid) {
            if (withFusion) {
                let message = JSON.stringify({
                    fusion: 'loadJSModules'
                });
                let results = theWindow.prompt(message);
                try {
                    results = JSON.parse(results);
                    this.registerModules(results);
                } catch (e) {}
            }
        } else {
            let self = this;
            if (theWindow.loadJSModules) {
                theWindow.loadJSModules(function(modules) {
                    self.registerModules(modules);
                });
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/fusion/src/core/bridge.js